import type {
  StringValidatorFn,
  StringValidatorInput,
  ValidateReturn,
} from '../formValidator.types';

import {
  getValidateForbiddenCharsFn,
  getValidateMaxLengthFn,
  getValidateMinLengthFn,
  getValidateRequiredFn,
} from '.';
import type {
  ForbiddenOptions,
  MaxLengthOptions,
  MinLengthOptions,
  RequiredOptions,
} from '.';

type NameOptions = {
  forbiddenOptions?: ForbiddenOptions;
  maxLengthOptions?: MaxLengthOptions;
  minLengthOptions?: MinLengthOptions;
  requiredOptions?: RequiredOptions;
};

const defaultOptions: NameOptions = {};

function validateInput(
  input: StringValidatorInput = '',
  options: Partial<NameOptions> = defaultOptions,
): ValidateReturn {
  const opts = { ...defaultOptions, ...options };
  return (
    getValidateRequiredFn(opts.requiredOptions || {})(input) ||
    getValidateMinLengthFn(opts.minLengthOptions || {})(input) ||
    getValidateMaxLengthFn(opts.maxLengthOptions || {})(input) ||
    getValidateForbiddenCharsFn(opts.forbiddenOptions || {})(input)
  );
}

export const validateName = (input: StringValidatorInput): ValidateReturn =>
  validateInput(input);

export const getValidateNameFn = (
  options: Partial<NameOptions>,
): StringValidatorFn => {
  return (input: StringValidatorInput) => validateInput(input, options);
};
